import { PageDefaultSegmentWithHeader } from "@sis/react-library"
import { listAndDetailSamplesRoutes, listAndDetailSamplesRoutesCombined } from "../../ListAndDetailSamplesNavigation";
import { useMatch, useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";

export const ListAndDetailSamplesPaginationEditPage = () => {

  const navigate = useNavigate();
  const match = useMatch(listAndDetailSamplesRoutesCombined.pagination_editMatch);
  const id = match?.params.id;

  const returnToList = () => {
    navigate(listAndDetailSamplesRoutes.pagination);
  }

  return (
    <PageDefaultSegmentWithHeader
      headingText='Pagination edit'
      standardWidth
    >
      You selected
      {id &&
        <> item {id}.</>
      }
      {!id &&
        <> a new item</>
      }
      <Box sx={{ paddingTop: '40px' }}>
        <Button
          variant="outlined"
          onClick={returnToList}
        >
          Close
        </Button>
      </Box>
    </PageDefaultSegmentWithHeader>
  )
}
